module.exports = __webpack_public_path__ + "a89c8683daea3659043fc22b7f4da2aa.jpg";